import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import { Box } from '../layout/Box.js';
import { Stack } from '../layout/Stack.js';
import '../layout/AnimatedBox.js';
import '../layout/Scrollbars.js';
import React__default from 'react';
import styled from 'styled-components';
import { TableContainer } from './TableContainer.js';
var StyledTable = styled(Stack)({
  overflowX: "auto"
});
StyledTable.defaultProps = {
  direction: "column",
  border: "base",
  borderRadius: "16px",
  borderColor: "grey.5",
  spacing: "8px"
};
var Table = function Table(_a) {
  var children = _a.children,
    rest = __rest(_a, ["children"]);
  return React__default.createElement(Box, {
    display: "flex",
    overflowX: "auto"
  }, React__default.createElement(TableContainer, null, React__default.createElement(StyledTable, __assign({}, rest), children)));
};
export { Table };